import { CategoryCard } from './CategoryCard';
import { shopByPopularCategories } from './PopularCategories';

export const Food = () => {
  return (
    <CategoryCard
      image={shopByPopularCategories[1].image}
      description={shopByPopularCategories[1].desc}
      title={shopByPopularCategories[1].title}
      link={shopByPopularCategories[1].link}
      buttonText="SHOP NOW"
      maxImageWidth="300px"
    />
  );
};
